import { Action } from '@ngrx/store';
import { ShopsView } from '../../../_generated';

export enum ShopsAction {
  Load = '[Shops] Load',
  Get = '[Shops] Get',
  Reset = '[Shops] Reset',
}

export class Load implements Action {
  readonly type = ShopsAction.Load;
}

export class Get implements Action {
  readonly type = ShopsAction.Get;

  constructor(public payload: ShopsView[]) {}
}

export class Reset implements Action {
  readonly type = ShopsAction.Reset;
}

export type ShopsActionType = Load | Get | Reset;
